export function checkEmail(params) {
  const reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
  return !reg.test(params) ? true : false
}

export function checkPass(params) {
  const reg = /^(?!\D+$)(?![^a-zA-Z]+$)\S{6,15}$/ //验证密码  6至15位的字母+数字
  return !reg.test(params) ? true : false
}

export function checkPhone(phone: string) {
  if (phone.length !== 11) return false
  return /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[1389])/.test(phone)
}

export function checkLnt(params) {
  const reg = /^[\-\+]?(0(\.\d{1,10})?|([1-9](\d)?)(\.\d{1,10})?|1[0-7]\d{1}(\.\d{1,10})?|180\.0{1,10}|180)$/
  return !reg.test(params) ? true : false
}

export function checkLat(params) {
  const reg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/
  return !reg.test(params) ? true : false
}

export function checkNumber(params) {
  const reg = /^([1-9]\d*\.?\d*)|(0\.\d*[1-9])|0$/
  return !reg.test(params) ? true : false
}
